module.exports = __webpack_public_path__ + "img/Supervisor.dab0924.svg";